import { Routes, Route } from "react-router-dom";
import WiFi from "./Pages/WiFi";
import RoomPolicy from "./Pages/RoomPolicy";
import ThingsToDo from "./Pages/ThingsToDo";
import Contact from "./Pages/Contact";
import Menu from "./Pages/Menu";
import Dashboard from "./Pages/Dashboard";
import Register from "./Pages/Register";
import ViewOrder from "./Pages/ViewOrder";
import OrderProcessing from "./Pages/OrderProcessing";
import Orders from "./Pages/Orders";
import ThingsToDoSingle from "./Pages/ThingsToDoSingle";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/registration" element={<Register />} />
      <Route path="/roompolicy" element={<RoomPolicy />} />
      <Route path="/wifi" element={<WiFi/>} />
      <Route path="/menu" element={<Menu />} />
      <Route path="/vieworder" element={<ViewOrder />} />
      <Route path="/orderprocessing" element={<OrderProcessing />} />
      <Route path="/recentorders" element={<Orders />} />
      <Route path="/thingstodo" element={<ThingsToDo />} />
      <Route path="/thingstodo/:slug" element={<ThingsToDoSingle />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
  );
}

export default App;
